import { createFileRoute, Navigate } from '@tanstack/react-router';
import { members } from '@personal-blog/contracts';
import { PageShell, Spinner } from '@viquard/doc-ui';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { useMe } from '@/features/auth/api';
import { NewsletterPage } from '@/features/newsletters';

function NewsletterRoute(): ReactNode {
  return (
    <AuthGuard>
      <ManagerNewsletterPage />
    </AuthGuard>
  );
}

function ManagerNewsletterPage(): ReactNode {
  const me = useMe();
  if (me.isPending) {
    return (
      <PageShell
        role="status"
        aria-live="polite"
        className="flex min-h-[60vh] items-center justify-center"
        style={{ color: 'var(--vq-ink-3)' }}
      >
        <Spinner size="md" />
      </PageShell>
    );
  }
  if (me.data == null) return <Navigate to="/login" replace />;

  const rank = members.ROLE_DEFS[me.data.user.role].rank;
  if (rank < members.ROLE_DEFS.manager.rank) return <Navigate to="/dashboard" replace />;

  return <NewsletterPage />;
}

export const Route = createFileRoute('/desk/newsletter')({
  component: NewsletterRoute,
});
